import { useContext } from 'preact/hooks';
import { ApiKeyContext } from '../components/api-key-provider';
var useApiKey = function () { return useContext(ApiKeyContext); };
export default useApiKey;
